import * as React from "react";

function SvgLevelMedium(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 36 32" {...props}>
      <g
        fill="#A681EF"
        stroke="#61B6E1"
        strokeWidth={2}
        fillRule="evenodd"
        strokeLinecap="round"
      >
        <path opacity={0.3} d="M26.5 7.5v17" />
        <path d="M18.5 15.5v9M10.5 18.5v6" />
      </g>
    </svg>
  );
}

export default SvgLevelMedium;
